export async function loadScript(url: string, id: string): Promise<void> {
  // Prevent duplicate script loading
  if (document.getElementById(id)) {
    return;
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.id = id;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));

    document.head.appendChild(script);
  });
}
